import script from "./detailSales.vue?vue&type=script&setup=true&lang=js"
export * from "./detailSales.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__